/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SendNotificationRequest } from '../models/SendNotificationRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class InternalService {
    /**
     * Send notification to user via WebSocket
     * Called by workers to notify users of job completion
     * @param requestBody
     * @returns any Ok
     * @throws ApiError
     */
    public static sendNotification(
        requestBody: SendNotificationRequest,
    ): CancelablePromise<{
        success: boolean;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/internal/notifications/send',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
